import React from 'react'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { emailSendEmailLink, emailSentEmailsLink, emailTemplatesLink } from '../routeLinks';

const AdminNavbar = ({ isAdmin = false }) => {
    if (!isAdmin) return <></>

    return <>
        <UncontrolledDropdown nav inNavbar className='fobk-dropdown'>
            <DropdownToggle nav caret>
                Email
            </DropdownToggle>
            <DropdownMenu end>
                <DropdownItem href={emailSendEmailLink}>
                    Send Email
                </DropdownItem>
                <DropdownItem href={emailTemplatesLink}>
                    Templates
                </DropdownItem>
                <DropdownItem href={emailSentEmailsLink}>
                    Sent Emails
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
        <UncontrolledDropdown nav inNavbar className='fobk-dropdown'>
            <DropdownToggle nav caret>
                Events
            </DropdownToggle>
            <DropdownMenu end>
                <DropdownItem href='/eventlist'>
                    List
                </DropdownItem>
                <DropdownItem href='/eventmanagement'>
                    Management
                </DropdownItem>
            </DropdownMenu>
        </UncontrolledDropdown>
        <div className='vertical-divider' />
    </>
}

export default AdminNavbar;
